module.exports = __webpack_public_path__ + "static/media/squadTiming.5cc0106b.png";